import React from 'react';
import { Box } from '@mui/material';

function Map() {
    const z = 16;
    const mapSource = `https://maps.google.com/maps?q=Lawendowy%20dotyk%20dla%20zdrowia%20i%20cia%C5%82a%2C%20%C5%81agiewnicka%2085%2C%20%C5%81%C3%B3d%C5%BA&t=&z=${z}&ie=UTF8&iwloc=&output=embed`;

    return (
        <Box
            sx={{
                width: { xs: '95%', md: '70%' },
                height: { xs: '350px', md: '600px' },
                borderRadius: 4,
                overflow: 'hidden',
                boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
                margin: '0 auto',
                mt: 4,
                mb: 4
            }}
        >
            <iframe
                title="Mapa dojazdu - Lawendowy Dotyk"
                src={mapSource}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen={true}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </Box>
    );
}

export default Map;